import packageJson from '../../package.json';

export const environment = {
  production: true,
  useEmulators: false,
  appType: 'link',
  environmentName: 'link',
  version: packageJson.version + 'b' + packageJson.buildNumber,
  firebaseConfig: {
    apiKey: 'AIzaSyCCRYS-rO2a7c4Sv5G6yAG84_xWHatwccY',
    authDomain: 'conversia-prod.firebaseapp.com',
    projectId: 'conversia-prod',
    storageBucket: 'conversia-prod.appspot.com',
    messagingSenderId: '59284278643',
    appId: '1:59284278643:web:96d83e56081b230baf8906',
    measurementId: 'G-2SKBKWM9TD'
  },
  gameInfoTimeOut: 50000,
  defaultInactivityTimeOut: 1800000, // 30 minutos

  expressiaFirebaseConfig: {
    apiKey: 'AIzaSyADpoYwVt9JkVsylMcGDzECPJyYv84MekQ',
    authDomain: 'expressia-a2020.firebaseapp.com',
    databaseURL: 'https://expressia-a2020.firebaseio.com',
    projectId: 'expressia-a2020',
    storageBucket: 'expressia-a2020.appspot.com',
    messagingSenderId: '538748346517',
    appId: '1:538748346517:web:5c69a7ea46e1cba817bb9c',
    measurementId: 'G-L3RRMZK919'
  },

  mainDomain: 'linkweb.conversia.life',
  functionsDomain: 'us-central1-conversia-prod.cloudfunctions.net'
  // Use named Firestore database for 'link' builds
  ,firestoreDatabase: 'link'
};
